/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';

export default function SearchIcon({ size = 'small', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
        color: 'currentColor',
      }}
      {...rest}
      viewBox="0 0 30 30"
    >
      <g>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M12.75 22.5C7.365 22.5 3 18.135 3 12.75S7.365 3 12.75 3s9.75 4.365 9.75 9.75a9.712 9.712 0 01-2.346 6.344l6.775 6.774a.75.75 0 01-1.06 1.06l-6.775-6.774A9.712 9.712 0 0112.75 22.5zm0-1.5a8.25 8.25 0 100-16.5 8.25 8.25 0 000 16.5z"
        ></path>
      </g>
    </svg>
  );
}
